(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2261],{

/***/ 66618:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trip-planner",
      function () {
        return __webpack_require__(44766);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ trip_planner; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/OutsidePageWrapper.tsx
var OutsidePageWrapper = __webpack_require__(55368);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/InsidePageWrapper.tsx
var InsidePageWrapper = __webpack_require__(70996);
// EXTERNAL MODULE: ../ui/src/components/Button/Button.tsx
var Button = __webpack_require__(57100);
// EXTERNAL MODULE: ./modules/Pages/TripPlanner/MainBanner/MainBanner.tsx
var MainBanner = __webpack_require__(3696);
// EXTERNAL MODULE: ./modules/Pages/TripPlanner/ReservationSection/ReservationSection.tsx
var ReservationSection = __webpack_require__(30503);
// EXTERNAL MODULE: ./modules/Pages/TripPlanner/FiltersSection/FiltersSection.tsx + 3 modules
var FiltersSection = __webpack_require__(23763);
// EXTERNAL MODULE: ./modules/Pages/TripPlanner/PlannerChecklist/PlannerChecklist.tsx + 10 modules
var PlannerChecklist = __webpack_require__(65947);
// EXTERNAL MODULE: ./modules/Pages/TripPlanner/TripPlannerContext.tsx
var TripPlannerContext = __webpack_require__(55377);
// EXTERNAL MODULE: ./modules/TripPlanner/hooks.ts
var hooks = __webpack_require__(4139);
// EXTERNAL MODULE: ../ui/src/components/Modal/ConfirmationModal.tsx
var ConfirmationModal = __webpack_require__(3177);
// EXTERNAL MODULE: ../ui/src/components/Form/Form/SubmitButton.tsx
var SubmitButton = __webpack_require__(90016);
// EXTERNAL MODULE: ./modules/Pages/TripPlanner/PlannerNameForm/PlannerNameForm.tsx
var PlannerNameForm = __webpack_require__(5914);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@13.0.3-canary.1_rlaikcoslzwwtqyk7brpdzej5y/node_modules/next/router.js
var next_router = __webpack_require__(51516);
// EXTERNAL MODULE: ./modules/Toast/Toast.tsx + 3 modules
var Toast = __webpack_require__(39890);
// EXTERNAL MODULE: ./utils/useAnalytics.tsx
var useAnalytics = __webpack_require__(24900);
;// CONCATENATED MODULE: ./modules/Pages/TripPlanner/TripPlannerAction/SaveButton.tsx








const SaveButton = ()=>{
    const { onCreatePlanner  } = (0,useAnalytics/* useAnalytics */.z)();
    const router = (0,next_router.useRouter)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const { onSavePlanner , onNameChange , planner  } = (0,TripPlannerContext/* useTripPlanerContext */.J6)();
    const handleSavePlan = async (submitData)=>{
        await onSavePlanner({
            ...planner,
            name: submitData.name
        }, async ()=>{
            onCreatePlanner();
            (0,Toast/* successToast */.Qm)({
                description: "You are ready to go! The checklist is saved on your profile"
            });
            onNameChange(submitData.name);
            await router.push("/users/me/checklists/");
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                variant: "outline",
                onClick: ()=>setIsOpen(true),
                children: "Save"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationModal/* ConfirmationModal */.c, {
                contentClassName: "!max-w-[600px]",
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                onConfirm: onSavePlanner,
                actionButtons: ()=>null,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlannerNameForm/* PlannerNameForm */.J, {
                    onCancel: ()=>setIsOpen(false),
                    renderButtons: (submit)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                    size: "sm",
                                    variant: "outline",
                                    onClick: ()=>setIsOpen(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitButton/* SubmitButton */.M, {
                                    size: "sm",
                                    onClick: (e)=>submit(handleSavePlan)(e),
                                    children: "Save"
                                })
                            ]
                        })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./modules/Auth/AuthContext.tsx
var AuthContext = __webpack_require__(35836);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-auth@4.24.5_aqiqc4vv7pffmc2pmelp4wqb4e/node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(19266);
// EXTERNAL MODULE: ./utils/useButtonsAnalytics.tsx
var useButtonsAnalytics = __webpack_require__(76356);
;// CONCATENATED MODULE: ./modules/Pages/TripPlanner/CreateTripPlanner.tsx













const CreateTripPlanner = ()=>{
    (0,useButtonsAnalytics/* useButtonsAnalytics */.V)();
    const { useSession  } = (0,AuthContext/* useAuth */.a)();
    const session = useSession();
    const { useSaveTripPlanMutationQuery  } = (0,hooks/* usePlanner */.P)();
    const saveTripPlan = useSaveTripPlanMutationQuery();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full bg-[#5c7eb4]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsidePageWrapper/* InsidePageWrapper */.n, {
                className: "flex flex-col gap-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MainBanner/* MainBanner */.$, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReservationSection/* ReservationSection */.N, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TripPlannerContext/* TripPlannerProvider */.WQ, {
                        onSavePlan: saveTripPlan.mutateAsync,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FiltersSection/* FiltersSection */.O, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlannerChecklist/* PlannerChecklist */.f, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full mt-8 flex justify-end",
                                    children: session && session.data ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SaveButton, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                        variant: "outline",
                                        onClick: ()=>(0,next_auth_react.signIn)("cognito"),
                                        children: "Sign in to save your checklist"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./pages/trip-planner/index.tsx

var __N_SSP = true;
/* harmony default export */ var trip_planner = (CreateTripPlanner);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5620,2931,6249,9713,916,936,7770,9774,2888,179], function() { return __webpack_exec__(66618); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);